export const getQueryError = (error: unknown) => ({
  data: error instanceof Error ? error.message : String(error),
  status: 'CUSTOM_ERROR',
})
